import { render, staticRenderFns } from "./indexPie.vue?vue&type=template&id=03c51998&scoped=true"
import script from "./indexPie.vue?vue&type=script&lang=js"
export * from "./indexPie.vue?vue&type=script&lang=js"
import style0 from "./indexPie.vue?vue&type=style&index=0&id=03c51998&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c51998",
  null
  
)

export default component.exports